
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('defs',[_c('path',{attrs:{"id":"a","vector-effect":"non-scaling-stroke","d":"M0 .172h19.52V8H0z"}}),_c('path',{attrs:{"id":"c","vector-effect":"non-scaling-stroke","d":"M.715.22h8.103v14.305H.715z"}})]),_c('g',{attrs:{"fill-rule":"evenodd","fill":"none"}},[_c('path',{attrs:{"vector-effect":"non-scaling-stroke","d":"M0 0h32v32H0z"}}),_c('g',{attrs:{"transform":"translate(6 17.78)"}},[_c('mask',{attrs:{"fill":"#fff","id":"b","vector-effect":"non-scaling-stroke"}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":"#a","vector-effect":"non-scaling-stroke"}})]),_c('path',{attrs:{"mask":"url(#b)","fill":"#FFF","d":"M18.77.274a.75.75 0 00-.75.75V6.5H1.5V.922a.75.75 0 10-1.5 0V7.25c0 .414.336.75.75.75h18.02a.75.75 0 00.75-.75V1.024a.75.75 0 00-.75-.75","vector-effect":"non-scaling-stroke"}})]),_c('g',{attrs:{"transform":"translate(11 6.78)"}},[_c('mask',{attrs:{"fill":"#fff","id":"d","vector-effect":"non-scaling-stroke"}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":"#c","vector-effect":"non-scaling-stroke"}})]),_c('path',{attrs:{"mask":"url(#d)","fill":"#FFF","d":"M1.465 5.017a.744.744 0 00.53-.22L4.04 2.751v11.024a.75.75 0 001.5 0V2.795l1.996 1.996a.75.75 0 101.06-1.06L5.322.454C5.317.45 5.31.448 5.307.445L5.299.431C5.277.41 5.246.4 5.22.38 5.189.357 5.158.332 5.123.315a.742.742 0 00-.885.117L.935 3.737a.749.749 0 00.53 1.28","vector-effect":"non-scaling-stroke"}})])])])])
          )
        }
      }
    